import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {GameObject} from '@specials/gcs-engine';

import {PointsEmitterPoolComponent} from './PointsEmitterPoolComponent';

export class PointsEmitter extends GameObject {
  constructor(public readonly emitterComponent: PointsEmitterPoolComponent) {
    super();

    this.addComponent(this.emitterComponent);
  }
}

injected(PointsEmitter, DI_TOKENS.clickerGamePointsEmitterPoolComponent);
